import WGLLog from './logger';

const _logInfo = (msg) => {
  WGLLog.info(null, null, msg);
};

const _logError = (msg) => {
  WGLLog.error(null, null, msg);
};

class WGLContext {
  static get(canvas) {
    let gl = null;

    try {
      gl =
        canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    } catch (e) {
      _logError('Unable to obtain WebGLRenderingContext!');
      WGLLog.errorRaw(e);
      return null;
    }

    if (!gl) {
      _logError('Unable to obtain WebGLRenderingContext!');
      return null;
    }

    _logInfo('Got WebGLRenderingContext');
    return gl;
  }
}

export default WGLContext;
